import { apiClient } from './api/client'
import { Alert, AlertsBootstrap, MarkAllReadResult } from '@/types/alerts'

class AlertsService {
  private baseUrl = '/alerts'

  async getBootstrap(limit = 20): Promise<AlertsBootstrap> {
    const res = await apiClient.get<AlertsBootstrap>(`${this.baseUrl}/bootstrap?limit=${limit}`)
    return res.data
  }

  async markRead(id: number): Promise<Alert> {
    const res = await apiClient.patch<Alert>(`${this.baseUrl}/${id}/read`)
    return res.data
  }

  async markAllRead(): Promise<MarkAllReadResult> {
    const res = await apiClient.patch<MarkAllReadResult>(`${this.baseUrl}/read-all`)
    return res.data
  }
}

export const alertsService = new AlertsService()
